module.exports = __webpack_public_path__ + "img/P17b_Tim's Poppies-2.3c7c3d95.jpg";